import { render, staticRenderFns } from "./ReservationSuccess.vue?vue&type=template&id=64373994"
import script from "./ReservationSuccess.vue?vue&type=script&lang=js"
export * from "./ReservationSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports